export const TRACKING_EVENTS = {
  LANDING: {
    LANDING_HIT: "landing:landing_hit",
  },
  APP: {
    APP_VIEWED: "app:app_viewed",
    AUTH_VIEWED: "app:auth_viewed", // page or modal
    ACCOUNT_CREATED_VIEWED: "app:account_created_viewed", // page or modal
    PRICING_VIEWED: "app:pricing_viewed", // page or modal
    CLICKED_SELECT_PLAN: "app:clicked_select_plan",
    VIEWED_CHECKOUT_SUMMARY: "app:viewed_checkout_summary",
    CLICKED_CHECKOUT: "app:clicked_checkout",
    VIEWED_PAYMENT_SUCCESS: "app:viewed_payment_success",
  },
};
